import { useState } from 'react';
import { toast } from 'sonner';
import { Crown, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { ownerApi, apiError } from './ownerApi';

export const OwnerLogin = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await ownerApi.post('/platform-owner/login', { username, password });
      onLogin(data.access_token);
    } catch (err) { toast.error(apiError(err)); } finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 px-6">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-white/10 bg-white/5 p-8 text-white backdrop-blur-xl" data-testid="owner-login-form">
        <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-orange-500"><Crown className="h-6 w-6" /></span>
        <h1 className="mt-5 text-2xl font-bold">Platform Sahibi</h1>
        <p className="mt-1 text-sm text-slate-400">Yönetim paneline giriş</p>
        <div className="mt-6 space-y-4">
          <div className="space-y-1.5"><Label className="text-slate-300">Kullanıcı adı</Label>
            <Input value={username} onChange={e => setUsername(e.target.value)} autoComplete="username" className="border-white/15 bg-white/5 text-white" data-testid="owner-login-username" /></div>
          <div className="space-y-1.5"><Label className="text-slate-300">Şifre</Label>
            <Input type="password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" className="border-white/15 bg-white/5 text-white" data-testid="owner-login-password" /></div>
        </div>
        <Button type="submit" disabled={busy || !username || !password} className="mt-6 w-full bg-orange-500 hover:bg-orange-600" data-testid="owner-login-submit">
          {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Giriş Yap
        </Button>
      </form>
    </div>
  );
};
